import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { navigateToUrl } from 'single-spa';
import { getTenant, selectMultiTenants } from '@ovpn-ui-toolkit/mf-common';
import { getPureTenantUrl, selectIsAWSCustomer } from '@cloud/shared';

import { Cloud } from '@ovpn-ui/icons';
import { unlockScroll } from '@ovpn-ui/utils';
import { TenantSwitcher, NavigationLink } from '@ovpn-ui/navigation';

export function AppTenantSwitcher(props: any) {
    const activeTenant = getTenant();

    const tenants: string[] = useSelector(selectMultiTenants);
    const hideTenantAddButton = useSelector(selectIsAWSCustomer);

    const tenantLinks: NavigationLink[] = useMemo(
        () =>
            tenants.map(t => ({
                icon: <Cloud className="tenant-menu-link-icon" />,
                label: t,
                to: getPureTenantUrl(t),
            })),
        [tenants],
    );

    const addTenant = useCallback(() => {
        navigateToUrl('/billing/domain-create');
        unlockScroll();
    }, []);

    return (
        <TenantSwitcher
            links={tenantLinks}
            content="openvpn.com"
            description={activeTenant}
            addTenant={addTenant}
            showFooter={!hideTenantAddButton}
            {...props}
        />
    );
}
